import { SettingsLeftSidebar } from 'pages/settings'
import { HomeLeftSidebar } from 'pages/home'

import { DappsSection, LinksSidebar, PlanSection } from './components'

const LeftSidebar = ({
	isHome,
	isdAppsPage,
	hasProjects
}: {
	isHome: boolean
	isdAppsPage: boolean
	hasProjects: boolean
}) => (
	<aside class='flex h-full min-h-96 flex-col justify-between border-r border-r-black-800 bg-black-850'>
		{isHome || isdAppsPage ? <HomeLeftSidebar /> : <SettingsLeftSidebar />}

		{hasProjects && <DappsSection />}

		<div class='mt-8'>
			{/* Links Section */}
			<LinksSidebar />

			{/* Plan Section */}
			<PlanSection />
		</div>
	</aside>
)

export { LeftSidebar }
